var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('import-attendances-attendance-import',{on:{"imported":_vm.loadData}}),_c('export-attendances-attendance-export',{ref:"export"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }